import apiFetch from '@/utils/apiFetch';
import { JwtResetPasswordKnownPayload } from './services/jwt/JwtAuthProvider';

export const apiRoutes = {
	signInUrl: '/portal/auth-jwt/',
	signInSocial: '/portal/auth-jwt-social/',
	requestOtp: '/portal/auth/request-otp/',
	getProfileDetails: '/portal/profile/details/',
	getProfileImage: '/portal/profile/user-logo/',
	authRefresh: '/portal/auth-jwt-refresh',
	mfaDetails: '/portal/2fa/user-details',
	mfaVerify: '/portal/2fa/verify-otp/',
	forgotPassword: '/portal/auth-forgot-password/',
	resetPassword: '/portal/auth-reset-password/',
	resetPasswordKnown: '/portal/auth-reset-password-logged-in/',
	mfaGenUri: '/portal/2fa/generate-uri/',
	socialOtp: '/portal/2fa/verify-oauth/',
	signUp: '/portal/sign-up/',
	signUpSocial: '/portal/sign-up-social/',
	signUpVerify: '/portal/sign-up-verify',
	resetEppPassword: '/portal/integrations/reset-epp/',
};



/**
 * Refreshes the access token
 */
export async function authRefreshToken(): Promise<Response> {
	return apiFetch(apiRoutes.authRefresh, { method: 'POST' });
}

/**
 * Sign in with token
 */
export async function authSignInWithToken(accessToken: string): Promise<Response> {
	return apiFetch(apiRoutes.getProfileDetails, {
		headers: { Authorization: `Bearer ${accessToken}` }
	});
}

/**
 * Sign in
 */
export async function authSignIn(credentials: { username: string; password: string, remember_me_token?: string }): Promise<Response> {
	return apiFetch(apiRoutes.signInUrl, {
		method: 'POST',
		body: JSON.stringify(credentials)
	});
}

/**
 *
 * @param credentials
 * @returns
 */
export async function authSignInSocial(credentials: { token: string, provider: string }): Promise<Response> {
	return apiFetch(apiRoutes.signInSocial, {
		method: 'POST',
		body: JSON.stringify(credentials)
	});
}

/**
 * OTP Sign In
 */
export async function authOtpSignIn(credentials: {
	username: string;
	password: string;
	remember_me_duration?: number,
	otp_code?: string,
	recovery_code?: string,
}): Promise<Response> {
	return apiFetch(apiRoutes.signInUrl, {
		method: 'POST',
		body: JSON.stringify(credentials)
	})
}

/**
 * MFA Generate the URI
 * @returns
 */
export async function authOtpGenerateURI() {
	return apiFetch(apiRoutes.mfaGenUri, {
		method: 'GET'
	})
}


/**
 * Fetch User
 */
export async function fetchUser({ token }: { token?: string }): Promise<Response> {
	return apiFetch(apiRoutes.getProfileDetails, {
		headers: { Authorization: `Bearer ${token}` }
	});
}

/**
 * Fetch profile picture
 */
export async function fetchProfilePicture({ accessToken }: { accessToken?: string }): Promise<Response> {
	if (!accessToken) {
		return apiFetch(apiRoutes.getProfileImage);
	}

	return apiFetch(apiRoutes.getProfileImage, {
		headers: { Authorization: `Bearer ${accessToken}` }
	});
}

/**
 * Sign up
 */
export async function authSignUp(data: { first: string; last: string; tel: string; email: string; passwd: string, jobtitle?: string; rar?: string, app_url: string }): Promise<Response> {
	return apiFetch(apiRoutes.signUp, {
		method: 'POST',
		body: JSON.stringify(data)
	});
}

/**
 *
 * @param credentials
 * @returns
 */
export async function authSignUpSocial(credentials: { token: string, provider: string, first: string; last: string; tel: string; passwd: string, jobtitle?: string; rar?: string, app_url: string }): Promise<Response> {
	return apiFetch(apiRoutes.signUpSocial, {
		method: 'POST',
		body: JSON.stringify(credentials)
	});
}

/**
 * Sign up verify
 */
export async function authSignUpVerify(data: { key: string }): Promise<Response> {
	return apiFetch(`${apiRoutes.signUpVerify}?key=${data.key}`, {
		method: 'GET',
	});
}



/**
 * Forgot password
 */
export async function authForgotPassword(data: { email: string, app_url: string }): Promise<Response> {
	return apiFetch(apiRoutes.forgotPassword, {
		method: 'POST',
		body: JSON.stringify(data)
	});
}

/**
 * Reset password
 */
export async function authResetPassword(data: { password: string, confirm_password: string, token: string }): Promise<Response> {
	return apiFetch(apiRoutes.resetPassword, {
		method: 'POST',
		body: JSON.stringify(data)
	});
}

/**
 * Verify EPP password reset
 */
export async function resetEppPassword(data: { key: string, epp_type: string }): Promise<Response> {
				return apiFetch(apiRoutes.resetEppPassword, {
					method: 'PATCH',
					body: JSON.stringify(data)
				})
			}
/**
 *
 */
export async function authSocialsOtp(data: {
	identifier: string;
	'2fa_type': string;
	otp_code?: string;
	remember_me_duration?: number;
	recovery_code?: string;
}): Promise<Response> {
	return apiFetch(apiRoutes.socialOtp, {
		method: 'POST',
		body: JSON.stringify(data)
	});
}

/**
 *
 * @param userId
 * @returns
 */
export async function authResetKnownPassword(data: JwtResetPasswordKnownPayload): Promise<Response> {
	return apiFetch(apiRoutes.resetPasswordKnown, {
		method: 'POST',
		body: JSON.stringify(data)
	});
}